import React from 'react';
import { useNavigate } from 'react-router-dom';

interface DisabledFeatureProps {
  featureName: string;
  consentType: string;
  description: string;
  icon?: string;
}

const DisabledFeature: React.FC<DisabledFeatureProps> = ({
  featureName,
  consentType,
  description,
  icon = '🔒',
}) => {
  const navigate = useNavigate();

  const consentDescriptions: Record<string, string> = {
    email_access: 'email access',
    ai_review: 'AI review',
    data_storage: 'data storage',
    web_crawl: 'web crawling',
  };

  return (
    <div
      style={{
        background: '#f5f5f5',
        border: '2px dashed #ccc',
        borderRadius: '8px',
        padding: '30px',
        textAlign: 'center',
        margin: '20px 0',
      }}
    >
      <div style={{ fontSize: '32px', marginBottom: '10px' }}>{icon}</div>
      <h3 style={{ margin: '10px 0', color: '#555' }}>{featureName} is Disabled</h3>
      <p style={{ color: '#777', margin: '10px 0 20px' }}>
        {description}
      </p>
      <p style={{ color: '#999', fontSize: '14px', margin: '10px 0 20px' }}>
        Enable <strong>{consentDescriptions[consentType] || consentType}</strong> in your settings to use this feature.
      </p>
      <button
        onClick={() => navigate('/settings')}
        style={{
          padding: '10px 24px',
          background: '#667eea',
          color: 'white',
          border: 'none',
          borderRadius: '6px',
          cursor: 'pointer',
          fontSize: '14px',
          fontWeight: 'bold',
          transition: 'all 0.2s ease',
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.background = '#5568d3';
          e.currentTarget.style.transform = 'translateY(-2px)';
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.background = '#667eea';
          e.currentTarget.style.transform = 'translateY(0)';
        }}
      >
        ⚙️ Go to Settings
      </button>
    </div>
  );
};

export default DisabledFeature;
